export default function mapRange(value: number, x1: number, y1: number, x2: number, y2: number) {
  return ((value - x1) * (y2 - x2)) / (y1 - x1) + x2
}

export function mapRangeWithFixedBounds(
  value: number,
  x1: number,
  y1: number,
  x2: number,
  y2: number,
) {
  const min = Math.min(x2, y2)
  const max = Math.max(x2, y2)
  return Math.min(max, Math.max(min, mapRange(value, x1, y1, x2, y2)))
}
